var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.125 45.125C10.3744 43.249 14.0604 42.2613 17.8125 42.2613C21.5646 42.2613 25.2506 43.249 28.5 45.125C31.7494 43.249 35.4354 42.2613 39.1875 42.2613C42.9396 42.2613 46.6256 43.249 49.875 45.125",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14.25C10.3744 12.374 14.0604 11.3863 17.8125 11.3863C21.5646 11.3863 25.2506 12.374 28.5 14.25C31.7494 12.374 35.4354 11.3863 39.1875 11.3863C42.9396 11.3863 46.6256 12.374 49.875 14.25",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14.25V45.125",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.25V45.125",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.875 14.25V45.125",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookBlue);
export default __webpack_public_path__ + "static/media/Icon_Book_Blue.07604f88ae39d7cc20372d3cfc2dcba4.svg";
export { ForwardRef as ReactComponent };